import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { SupplierChartProps } from "models/propTypes/supplierPropTypes";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
//#endregion
import { FormFieldConstants } from "utils/constants";
import { UrlHelper, QueryStateHelper } from "utils/helpers";
import { useLocation, useNavigate } from "react-router-dom";

const InvoiceTotalByMonthChart: React.FC<SupplierChartProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const filter: Omit<WintSuperkollAPIModel.IncomingInvoiceFilter, keyof WintUtilsWebApi.Filter> = {
    onlyMine: false,
    supplierId: props.supplierId,
  };

  const labelFormatter = (label?: string) => {
    return label ? label.substring(0, 3) : "";
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Bar}
      chartAPIKey={GraphConstants.ChartKeys.SupplierInvoiceTotalByMonth}
      accumulatedChartAPIKey={GraphConstants.ChartKeys.SupplierInvoiceTotalAccumulated}
      labelFormatter={labelFormatter}
      filter={filter}
      useClickableChart
      onPeriodClick={(args) => {
        const params = new URLSearchParams("");
        const dateEncoder = QueryStateHelper.dateRangeQueryEncoder(
          FormFieldConstants.IncomingInvoice.Filter.InvoiceDate
        );
        dateEncoder.urlEncode(params, undefined, { start: args.start, end: args.end });

        if (props.supplierName) {
          const suppliersEncoder = QueryStateHelper.multipleAutoCompleteItemsQueryEncoder(
            FormFieldConstants.IncomingInvoice.Filter.Suppliers
          );
          suppliersEncoder.urlEncode(params, undefined, [{ id: props.supplierId, value: props.supplierName }]);
        }

        navigate(UrlHelper.formatPath(`/Reports/Expenses/IncomingInvoices?${params.toString()}`), {
          state: { background: location },
        });
      }}
    />
  );
};

export default InvoiceTotalByMonthChart;
